   import router from '@/router';
   import store from '@/store/index';
   import {
     Loading,
     Message
   } from 'element-ui';
   import {
     axiosRequest,
     axiosOptions
   } from "./request";
   import moment from "moment";

   /** 
    * js截取字符串，中英文都能用 
    * @param str：需要截取的字符串 
    * @param len: 需要截取的中文长度 
    */
   export const cutstr = (str, len) => {
     if (!str || !len) {
       return "";
     }

     let str_length = 0;
     let str_len = 0;
     let str_cut = new String();

     str_len = str.length;
     for (var i = 0; i < str_len; i++) {
       let char = str.charAt(i);
       str_length++;
       //判断双字节字符占2
       if (/[^\x00-\xff]/.test(char)) {
         str_length++;
       }
       str_cut = str_cut.concat(char);
       if (str_length >= len) {
         str_cut = str_cut.concat("...");
         return str_cut;
       }
     }

     //如果给定字符串小于指定长度，则返回源字符串；  
     if (str_length < len) {
       return str;
     }
   }

   /**
    * 下载报告全文
    * @param type 0发现报告，1数据情报
    * @param id 报告id
    * @param title 报告标题
    * @param suffix 文件后缀
    */
   export const downloadReport = (type, id, title, suffix) => {
     const loading = Loading.service({
       lock: true,
       text: "下载中...",
       spinner: "el-icon-loading",
       background: "rgba(0, 0, 0, 0.7)",
     });

     let url = `${process.env.VUE_APP_BASE_API}`;
     switch (type) {
       case 0:
         url += "/file/download-report?id=" + id;
         break;
       case 1:
         url += "/file/download-data-intelligence-pdf?id=" + id;
         break;
     }

     const xhr = new XMLHttpRequest();
     xhr.open("get", url, true);
     xhr.responseType = "arraybuffer";
     xhr.setRequestHeader(
       "authorization",
       "Bearer " + localStorage.getItem("token")
     );
     xhr.setRequestHeader(
       "x-authorization",
       "Bearer " + localStorage.getItem("refreshToken")
     );
     xhr.onreadystatechange = function () {
       if (this.readyState === 4) {
         if (this.status === 200) {
           updateLoginUserInfo();

           try {
             let filename = title + suffix; //"";
             // let disposition = this.getResponseHeader("content-disposition");
             // let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
             // let matches = filenameRegex.exec(disposition);
             // if (matches != null && matches[1]) {
             //   // filename = decodeURI(
             //   //   matches[1].replace(/['"]/g, "").substring(5)
             //   // );

             //   // console.debug(
             //   //   decodeURIComponent(matches[1].replace(/['"]/g, ""))
             //   // );
             //   // console.log(
             //   //   decodeURIComponent(matches[1].replace(/['"]/g, ""))
             //   // );
             //   // filename = decodeURIComponent(
             //   //   matches[1].replace(/['"]/g, "").substring(5)
             //   // );
             //   //filename = decodeURIComponent(matches[1].replace(/['"]/g, "")).substring(5);
             //   filename = decodeURIComponent(
             //     matches[1].replace(/['"]/g, "")
             //   ).replace("utf-8", "");
             // }
             // console.debug(filename);
             // console.log(filename);

             let filetype = "";
             // let fileext = filename.substring(filename.lastIndexOf("."));
             // switch (fileext) {
             switch (suffix) {
               case ".pdf":
                 filetype = "application/pdf";
                 break;
               case ".doc":
                 filetype = "application/msword";
                 break;
               case ".docx":
                 filetype =
                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                 break;
               case ".xls":
                 filetype = "application/vnd.ms-excel";
                 break;
               case ".xlsx":
                 filetype =
                   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                 break;
               case ".ppt":
                 filetype = "application/vnd.ms-powerpoint";
                 break;
               case ".pptx":
                 filetype =
                   "application/vnd.openxmlformats-officedocument.presentationml.presentation";
                 break;
             }

             let blob = new Blob([xhr.response], {
               type: filetype,
             });
             if (window.navigator && window.navigator.msSaveBlob) {
               // deal with IE 11, data是第一步toBlob的结果值
               window.navigator.msSaveOrOpenBlob(blob, filename);
             } else {
               let link = document.createElement("a");
               link.href = window.URL.createObjectURL(blob);
               link.download = filename;
               link.click();
               window.URL.revokeObjectURL(link.href);
             }

             loading.close();
           } catch {
             loading.close();
             Message.error({
               message: "下载失败，请稍后重试",
               customClass: "z-index-9999",
             });
           }
         } else if (this.status === 401) {
           loading.close();
           localStorage.removeItem("token");
           localStorage.removeItem("logined");
           store.commit("setLogined", false);
           // location.href = "/login";
           router.push(
             "/login?returnUrl=" +
             encodeURIComponent(router.currentRoute.fullPath)
           );
         } else if (this.status === 501) {
           loading.close();
           Message.error({
             message: "积分余额不足或超出每日积分限额，请明天再试",
             customClass: "z-index-9999",
           });
         } else {
           loading.close();
           Message.error({
             message: "下载失败，请稍后重试",
             customClass: "z-index-9999",
           });
         }
       }
     };
     xhr.send();
   }

   /**
    * 下载数据情报图片
    * @param id 
    * @param currentPicTitle 
    */
   export const downloadDataIntelligenceImg = (id, currentPicTitle) => {
     const loading = Loading.service({
       lock: true,
       text: "下载中...",
       spinner: "el-icon-loading",
       background: "rgba(0, 0, 0, 0.7)",
     });

     let url =
       `${process.env.VUE_APP_BASE_API}` +
       "/file/download-data-intelligence-img?id=" +
       id;

     const xhr = new XMLHttpRequest();
     xhr.open("get", url, true);
     xhr.responseType = "arraybuffer";
     xhr.setRequestHeader(
       "authorization",
       "Bearer " + localStorage.getItem("token")
     );
     xhr.setRequestHeader(
       "x-authorization",
       "Bearer " + localStorage.getItem("refreshToken")
     );
     xhr.onreadystatechange = function () {
       if (this.readyState === 4) {
         if (this.status === 200) {
           updateLoginUserInfo();

           try {
             let filename = currentPicTitle + ".png";

             let filetype = "image/png";

             let blob = new Blob([xhr.response], {
               type: filetype,
             });
             if (window.navigator && window.navigator.msSaveBlob) {
               // deal with IE 11, data是第一步toBlob的结果值
               window.navigator.msSaveOrOpenBlob(blob, filename);
             } else {
               let link = document.createElement("a");
               link.href = window.URL.createObjectURL(blob);
               link.download = filename;
               link.click();
               window.URL.revokeObjectURL(link.href);
             }

             loading.close();
           } catch {
             loading.close();
             Message.error({
               message: "下载失败，请稍后重试",
               customClass: "z-index-9999",
             });
           }
         } else if (this.status === 401) {
           loading.close();
           localStorage.removeItem("token");
           localStorage.removeItem("logined");
           store.commit("setLogined", false);
           // location.href = "/login";
           router.push("/login?returnUrl=" + encodeURIComponent(router.currentRoute.fullPath));
         } else if (this.status === 501) {
           loading.close();
           Message.error({
             message: "积分余额不足或超出每日积分限额，请明天再试",
             customClass: "z-index-9999",
           });
         } else {
           loading.close();
           Message.error({
             message: "下载失败，请稍后重试",
             customClass: "z-index-9999",
           });
         }
       }
     };
     xhr.send();
   };

   /**
    * 统计数据导出下载excel
    * @param url 
    * @param data 
    */
   export const exportTongjiDownload = (url, activeCName, data) => {
     const loading = Loading.service({
       lock: true,
       text: "导出中...",
       spinner: "el-icon-loading",
       background: "rgba(0, 0, 0, 0.7)",
     });

     const xhr = new XMLHttpRequest();
     xhr.open("post", url, true);
     xhr.responseType = "arraybuffer";
     xhr.setRequestHeader(
       "authorization",
       "Bearer " + localStorage.getItem("token")
     );
     xhr.setRequestHeader(
       "x-authorization",
       "Bearer " + localStorage.getItem("refreshToken")
     );

     xhr.setRequestHeader(
       "content-type",
       "application/x-www-form-urlencoded;charset=utf-8"
     );
     xhr.onreadystatechange = function () {
       if (this.readyState === 4) {
         if (this.status === 200) {
           loading.close();

           updateLoginUserInfo();

           try {
             let filename =
               activeCName +
               "统计数据导出_" +
               dateFormat(new Date(), "yyyyMMDDHHmmss") +
               ".xlsx";
             // let disposition = this.getResponseHeader("content-disposition");
             // let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
             // let matches = filenameRegex.exec(disposition);
             // if (matches != null && matches[1]) {
             //   filename = decodeURIComponent(
             //     matches[1].replace(/['"]/g, "").substring(5)
             //   );
             // }

             let filetype = "";
             let fileext = filename.substring(filename.lastIndexOf("."));
             switch (fileext) {
               case ".pdf":
                 filetype = "application/pdf";
                 break;
               case "doc":
                 filetype = "application/msword";
                 break;
               case "docx":
                 filetype =
                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                 break;
               case ".xls":
                 filetype = "application/vnd.ms-excel";
                 break;
               case ".xlsx":
                 filetype =
                   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                 break;
             }

             let blob = new Blob([xhr.response], {
               type: filetype,
             });
             if (window.navigator && window.navigator.msSaveBlob) {
               // deal with IE 11, data是第一步toBlob的结果值
               window.navigator.msSaveOrOpenBlob(blob, filename);
             } else {
               let link = document.createElement("a");
               link.href = window.URL.createObjectURL(blob);
               link.download = filename;
               link.click();
               window.URL.revokeObjectURL(link.href);
             }
           } catch {
             Message.error("下载失败，请稍后重试");
           }
         } else if (this.status === 401) {
           loading.close();
           localStorage.removeItem("token");
           localStorage.removeItem("logined");
           store.commit("setLogined", false);
           //   location.href = "/login";
           router.push("/login?returnUrl=" + encodeURIComponent(router.currentRoute.fullPath));
         } else if (this.status === 501) {
           loading.close();
           Message.error("积分余额不足或超出每日积分限额，请明天再试");
         } else {
           loading.close();
           Message.error({
             message: "导出失败，请稍后重试",
             customClass: "z-index-9999",
           });
         }
       }
     };

     xhr.send(data);
   }

   export const updateLoginUserInfo = () => {
     axiosRequest(
       "/user/user-formation", {
         t: Date.now()
       },
       axiosOptions("get", "", "json")
     ).then((res) => {
       if (res.data && res.data.code === 200) {
         let userInfo = JSON.parse(localStorage.getItem("userInfo"));
         userInfo.id = res.data.data.id;
         userInfo.username = res.data.data.username;
         userInfo.headPhoto = res.data.data.headPhotoUrl;
         userInfo.integral = res.data.data.integral;
         userInfo.freeIntegral = res.data.data.freeIntegral;
         userInfo.vipType = res.data.data.vipType;
         userInfo.vipTime = res.data.data.vipTime;
         userInfo.workbenchAccess = res.data.data.workbenchAccess;
         localStorage.setItem("userInfo", JSON.stringify(userInfo));
         store.commit("setUserInfo", userInfo);
       }
     }).catch(() => {});
   }

   export const dateFormat = (cellValue, format) => {
     if (!cellValue) return "";
     return moment(cellValue).format(format);
   }

   //随机生成颜色
   export const randomRGBColor = () => {
     let color = '';
     let r = Math.floor(Math.random() * 256);
     let g = Math.floor(Math.random() * 256);
     let b = Math.floor(Math.random() * 256);
     color = `rgb(${r},${g},${b})`;
     return color; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换
   };
   //rgb颜色转十六进制
   export const colorHex = (string) => {
     var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
     if (/^(rgb|RGB)/.test(string)) {
       var aColor = string.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
       var strHex = "#";
       for (var i = 0; i < aColor.length; i++) {
         var hex = Number(aColor[i]).toString(16);
         if (hex === "0") {
           hex += hex;
         }
         strHex += hex;
       }
       if (strHex.length !== 7) {
         strHex = string;
       }
       return strHex;
     } else if (reg.test(string)) {
       var aNum = string.replace(/#/, "").split("");
       if (aNum.length === 6) {
         return string;
       } else if (aNum.length === 3) {
         var numHex = "#";
         for (var i = 0; i < aNum.length; i += 1) {
           numHex += (aNum[i] + aNum[i]);
         }
         return numHex;
       }
     } else {
       return string;

     }
   };

   /**
    * 删除用户报告
    * @param {*} id 
    * @param {*} type 
    * @returns 
    */
   export const delUserReport = (id, type) => {
     return new Promise((resolve, reject) => {
       axiosRequest(
           "/user-report/del", {
             id: id,
             type: type
           },
           axiosOptions("post", "", "json")
         )
         .then((res) => {
           resolve(res);
         }).catch((error) => {
           reject(error)
         });
     });
   };

   export const redirectSSOLogin = () => {
     location.href = `${process.env.VUE_APP_LOGIN_URL}?service=${process.env.VUE_APP_LOGIN_SERVICE_URL}login`;
   };

   export const redirectSSOLoginOut = () => {
     location.href = `${process.env.VUE_APP_LOGIN_OUT_URL}?service=${process.env.VUE_APP_LOGIN_SERVICE_URL}`;
   };

   export const redirectSSORegister = () => {
     location.href = `${process.env.VUE_APP_REGISTER_URL}`;
   };

   export const redirectSSOUserCenter = () => {
     window.open(`${process.env.VUE_APP_USER_CENTER_URL}`);
   };

   export const redirectSSOUserProfile = () => {
     window.open(`${process.env.VUE_APP_USER_PROFILE_URL}`);
   };
   